import { render, staticRenderFns } from "./archive-settings.vue?vue&type=template&id=7901b490&"
import script from "./archive-settings.vue?vue&type=script&lang=js&"
export * from "./archive-settings.vue?vue&type=script&lang=js&"
import style0 from "./archive-settings.vue?vue&type=style&index=0&lang=less&scope=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports